// PolitiqueConfidentialite.txt
import React from "react";

const PolitiqueConfidentialite = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Politique de confidentialité</h1>
        <p>Dernière mise à jour : {LAST_UPDATE}</p>
      </div>

      <section className="legal-section">
        <h2>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement est <strong>{TRADE_NAME}</strong> (Entrepreneur individuel).
          <br />
          Responsable : <strong>{OWNER_FULLNAME}</strong>
          <br />
          Adresse : {BUSINESS_ADDRESS}
          <br />
          Contact : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Données collectées</h2>
        <ul>
          <li>
            <strong>Contact / demande de projet</strong> : nom, email, contenu du message, et toute
            information transmise volontairement (brief, contraintes, etc.).
          </li>
          <li>
            <strong>Données de navigation</strong> : informations techniques et de consultation (adresse IP,
            identifiants cookies, pages visitées, interactions) via la mesure d’audience, selon votre
            choix de consentement.
          </li>
          <li>
            <strong>Newsletter</strong> (si activée) : email (et éventuellement prénom).
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>3. Finalités et bases légales</h2>
        <ul>
          <li>
            <strong>Répondre aux demandes</strong> (contact, devis, projet) — base légale :{" "}
            <em>mesures précontractuelles</em> et/ou <em>intérêt légitime</em>.
          </li>
          <li>
            <strong>Gestion de la relation</strong> (suivi, échanges) — base légale : <em>contrat</em>{" "}
            et/ou <em>intérêt légitime</em>.
          </li>
          <li>
            <strong>Newsletter</strong> — base légale : <em>consentement</em> (désinscription possible).
          </li>
          <li>
            <strong>Mesure d’audience</strong> (Google Analytics) — base légale : <em>consentement</em>.
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>4. Durées de conservation</h2>
        <ul>
          <li>Demandes via formulaire : {RETENTION_CONTACT}.</li>
          <li>Newsletter : jusqu’au retrait du consentement ou {RETENTION_NEWSLETTER}.</li>
          <li>Mesure d’audience (Google Analytics) : {RETENTION_ANALYTICS}.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>5. Destinataires et sous-traitants</h2>
        <p>
          Les données sont destinées à {TRADE_NAME} et peuvent être traitées par des prestataires
          techniques agissant comme sous-traitants.
        </p>
        <ul>
          <li>Hébergement (VPS) : Infomaniak Network SA</li>
          <li>Mesure d’audience : Google Analytics (Google)</li>
          <li>Emailing (si utilisé) : {EMAILING_PROVIDER}</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>6. Transferts hors Union européenne</h2>
        <p>
          Google Analytics peut impliquer des transferts de données vers des pays hors UE (notamment
          les États-Unis), selon la configuration et les services utilisés. Lorsque cela est requis,
          des garanties appropriées peuvent être mises en place (par ex. clauses contractuelles types).
        </p>
      </section>

      <section className="legal-section">
        <h2>7. Vos droits</h2>
        <p>
          Conformément au RGPD, vous disposez des droits suivants : accès, rectification, effacement,
          limitation, opposition, portabilité (selon les cas), et retrait du consentement.
        </p>
        <p>
          Pour exercer vos droits : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
        <p>Vous pouvez également introduire une réclamation auprès de la CNIL.</p>
      </section>

      <section className="legal-section">
        <h2>8. Mise à jour</h2>
        <p>
          Nous pouvons modifier cette politique. La date indiquée en haut de page correspond à la
          dernière mise à jour.
        </p>
      </section>
    </div>
  );
};

const LAST_UPDATE = "2026-02-19";

const TRADE_NAME = "ToCreate";
const OWNER_FULLNAME = " Loic SUNVÉ ÉRIMÉE";
const BUSINESS_ADDRESS = "6 ALL de la Palme d'Or, 78300 Poissy, FRANCE";
const CONTACT_EMAIL = "contact@tocreate.fr";

const EMAILING_PROVIDER = "Infomaniac";

const RETENTION_CONTACT = "12 mois à compter du dernier échange";
const RETENTION_NEWSLETTER = "3 ans après le dernier contact";
const RETENTION_ANALYTICS = "13 mois";

export default PolitiqueConfidentialite;
